import isArray from "lodash/isArray";

const validator = {
  getMessage() {
    return "The total number of files uploaded exceeds the maximum file number allowed.";
    // return field + " has " + max + " maximum number of files";
  },
  validate(value, max) {
    if (isArray(value)) {
      return value.length <= max;
    } else {
      if (max < 1) {
        return false;
      } else {
        return true;
      }
    }
  }
};

export default validator;
